import * as angular from 'angular';
import { getThoughtspotIntegrated } from '@mode/shared/util-js';

class GroupsPanelController {
  static $inject = ['$window'];

  private displayGroupsBrowser = true;
  private thoughtspotIntegrated: boolean;

  constructor(private $window: angular.IWindowService) {
    this.thoughtspotIntegrated = getThoughtspotIntegrated(this.$window.document);
  }

  handleCreateGroup() {
    this.reInitBrowser();
  }

  reInitBrowser() {
    this.displayGroupsBrowser = false;
    setTimeout(() => {
      this.displayGroupsBrowser = true;
    });
  }
}

export const GroupsPanelComponent: angular.IComponentOptions = {
  controller: GroupsPanelController,
  controllerAs: 'ctrl',
  bindings: {
    orgToken: '<',
    orgUsername: '<',
    userIsAdmin: '<',
    orgScimEnabled: '<',
  },
  template: `
  <div class="groups-panel-header">
    <div class="header-title">
      <h3 class="heading">Groups</h3>
    </div>
    <div class="header-actions">
      <capra-button class="action-button pull-right"
        ng-if="ctrl.userIsAdmin && !ctrl.thoughtspotIntegrated"
        create-group
        group-account="{{ctrl.orgUsername}}"
        on-create="ctrl.handleCreateGroup()"
        data-test="create-group"
        text="Create Group"
      ></capra-button>
    </div>
  </div>
  <div class="groups-panel-body">
    <groups-browser
      ng-if="ctrl.displayGroupsBrowser"
      org-token="ctrl.orgToken"
      org-scim-enabled="ctrl.orgScimEnabled"
    />
  </div>
  `,
};
